/*
  landing-mood.js
  Behaviour:
  - Top Splide slider of images (thumbs)
  - Clicking a thumb shows the corresponding content panel below
  - Swiping/moving the slider updates the visible panel

  Requirements:
  - Splide must be loaded globally before this runs
  - Markup generated by sections/landing-builder.liquid
*/

(function () {
  function qsa(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function setActive(root, targetId) {
    var panels = qsa(root, '.mood__panel');
    var btns = qsa(root, '.mood__thumb-btn');

    panels.forEach(function (p) {
      var isActive = p.id === targetId;
      p.classList.toggle('is-active', isActive);
    });

    btns.forEach(function (b) {
      var isActive = b.getAttribute('data-mood-target') === targetId;
      b.classList.toggle('is-active', isActive);
      b.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function initMood(root) {
    var splideEl = root.querySelector('[data-mood-splide]');
    if (!splideEl || typeof Splide === 'undefined') return;

    var btns = qsa(root, '.mood__thumb-btn');
    if (!btns.length) return;

    // Ensure one panel visible
    var firstBtn = btns[0];
    var firstTarget = firstBtn.getAttribute('data-mood-target');
    if (firstTarget) setActive(root, firstTarget);

    var splide = new Splide(splideEl, {
      type: 'loop',
      autoWidth: true,
      gap: '0px',
      pagination: false,
      arrows: false,
      drag: true,
      keyboard: 'global',
      speed: 600
    });

    var prevBtn = root.querySelector('.mood__prev');
    var nextBtn = root.querySelector('.mood__next');
    if (prevBtn) prevBtn.addEventListener('click', function () { splide.go('<'); });
    if (nextBtn) nextBtn.addEventListener('click', function () { splide.go('>'); });

    // Click-to-activate
    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.mood__thumb-btn');
      if (!btn || !root.contains(btn)) return;
      var targetId = btn.getAttribute('data-mood-target');
      if (!targetId) return;

      setActive(root, targetId);

      // Move slider to clicked thumb index
      var idx = btns.indexOf(btn);
      if (idx >= 0) splide.go(idx);

      // Optional: scroll panels into view
      // var panel = document.getElementById(targetId);
      // if (panel) panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // When slider moves (drag/swipe), update active panel
    splide.on('moved', function (newIndex) {
      var b = btns[newIndex];
      if (!b) return;
      var targetId = b.getAttribute('data-mood-target');
      if (!targetId) return;
      setActive(root, targetId);
    });

    splide.mount();
  }

  window.addEventListener('load', function () {
    document.querySelectorAll('[data-mood-root]').forEach(initMood);
  });
})();
